<div class="aligner-start w-full leaf-node-content" *ngIf="state.leafNodeValue">
  <y42-data-test-result-icon
    [status]="state.leafNodeValue"
    [errorMessages]="state.errorMessages"
  ></y42-data-test-result-icon>
</div>

<div class="w-full h-full aligner-start group-by-display" *ngIf="state.aggregationGroupArray">
  <div *ngFor="let val of state.aggregationGroupArray; trackBy: trackByFn" class="mr-2 aligner-start">
    <y42-data-test-result-icon [status]="val.type"></y42-data-test-result-icon>

    <div class="font-normal ml-1 fs-07">
      {{ val.count }}
    </div>
  </div>
</div>
